module.exports = __webpack_public_path__ + "static/media/gov-block.14d5afce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/gov-block.jpg
// module id = 1876
// module chunks = 147